import { useEffect } from "react";
import { ContactForm } from "../components/ContactForm/ContactForm";
import { Container } from "../components/Container/Container";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { Section } from "../components/Section/Section";
import { contact } from "../content/site";
import { setPageMeta } from "../utils/metadata";
import * as styles from "./pages.css";

export function Contact() {
  useEffect(() => {
    setPageMeta(
      "Contact",
      "Contact Ayro Technologies to discuss consulting, audits, bespoke software, or project management support."
    );
  }, []);

  return (
    <>
      <PageHeader
        eyebrow="Contact"
        title="Discuss a project, audit, or technical decision."
        intro="Tell us what you are trying to improve, build, recover, or understand. We will help shape the next sensible step."
      />
      <Section>
        <Container>
          <div className={styles.contactGrid}>
            <aside className={styles.contactPanel}>
              <h2 className={styles.sectionTitle}>Start the conversation</h2>
              <p>
                Email{" "}
                <a className={styles.contactLink} href={`mailto:${contact.email}`}>
                  {contact.email}
                </a>
              </p>
            </aside>
            <ContactForm />
          </div>
        </Container>
      </Section>
    </>
  );
}
